<template>
  <v-card class="card-border">
    <v-card-text>
      <v-form>
        <v-row dense align="center">
          <v-col cols="12" sm="12" md="4">
            <SelectEquipes @onChanged="equipe = $event" />
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <DateMenu label="Data Inicio" @onChanged="dateStart = $event" />
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <DateMenu label="Data Fim" @onChanged="dateEnd = $event" />
          </v-col>
          <v-col cols="12" sm="12" md="2">
            <v-btn outlined color="blue darken-2" rounded dark depressed small @click="buscar()">
              <v-icon left>mdi-magnify</v-icon>Buscar
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { Supervisor } from "@/services/dashboard";

export default {
  name: "Filtro",

  components: {
    DateMenu: () => import("@/components/datepicker/DateMenu"),
    SelectEquipes: () => import("./SelectEquipes")
  },

  data() {
    return {
      dateStart: null,
      dateEnd: null,
      serviceSupervisor: new Supervisor(),
      equipe: []
    };
  },

  computed: {
    ...mapGetters("dashboard", ["getRankLeads"]),
    ...mapGetters("dashboard", ["getRankNovos"]),
    ...mapGetters("dashboard", ["getRankUsados"]),
    ...mapGetters("dashboard", ["getRankConsorcio"]),
    ...mapGetters("dashboard", ["getHistoricoRank"]),
    ...mapGetters("dashboard", ["getLeads"])
  },

  methods: {
    ...mapActions("dashboard", ["setRankLeads"]),
    ...mapActions("dashboard", ["setRankNovos"]),
    ...mapActions("dashboard", ["setRankUsados"]),
    ...mapActions("dashboard", ["setRankConsorcio"]),
    ...mapActions("dashboard", ["setHistoricoRank"]),
    ...mapActions("dashboard", ["setLeads"]),

    async getRanks() {
      try {
        const rank = await this.serviceSupervisor.getRanks();
        this.setRankLeads([...rank]);
        this.setRankNovos([...rank]);
        this.setRankUsados([...rank]);
        this.setRankConsorcio([...rank]);
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },

    async getHistoricoRanksByEquipe() {
      try {
        const rank = await this.serviceSupervisor.getHistoricoRanksByEquipe(
          this.equipe
        );
        this.setHistoricoRank([...rank]);
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },

    async getLeadsByEquipe() {
      try {
        const leads = await this.serviceSupervisor.getLeadsByEquipe(
          this.dateStart,
          this.dateEnd,
          this.equipe
        );
        this.setLeads(leads);
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },

    async buscar() {
      try {
        this.getLeadsByEquipe();
        this.getHistoricoRanksByEquipe(this.equipe);
      } catch (error) {
        this.$toast.error("Erro ao carregar Dados");
        return Promise.reject(error);
      }
    }
  },

  async mounted() {
    try {
      if (
        this.getRankUsados.length == 0 ||
        this.getRankNovos.length == 0 ||
        this.getRankLeads.length == 0 ||
        this.getRankConsorcio.length == 0
      ) {
        await this.getRanks();
      }
      return Promise.resolve();
    } catch (error) {
      this.$toast.error("Erro ao carregar Dados");
      return Promise.reject(error);
    }
  }
};
</script>
